/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as UserSettlementService from '../../../services/userSettlementService'
import Currency from '../currency'
import { BASE_IMAGE_PATH } from '../../../configs/api';
class SettlementModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         amount: "",
         currUserData: {},
         remark: "",
         mpassword: "",
         toastMsg: "",
         toastType: "",
         amount_to_stl: 0,
         loading: true,
         buttonLoading: false
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   async submitData() {
      if (this.state.amount === "") {
         this.props.notify("Amount is not set", "error")
         return false
      }
      if (this.state.mpassword === "") {
         this.props.notify("Master password is not set", "error")
         return false
      }
      // if (parseFloat(parseFloat(this.state.amount).toFixed(2)) > parseFloat(parseFloat(Math.abs(this.state.amount_to_stl)).toFixed(2))) {
      if (Math.round(this.state.amount*100)/100 > Math.round(Math.abs(this.state.amount_to_stl)*100)/100) {
         this.props.notify("Settle Amount should not more than Amount to Settle", "error")
         return false
      }
      if (this.state.buttonLoading) {
         return false
      } else {
         this.setState({ buttonLoading: true }, async () => {
            let body = {
               "masterPassword": this.state.mpassword,
               "settlements": [
                  {
                     "balance": this.props.user.availableBalance,
                     "description": this.state.remark,
                     "pnl": (Math.round(this.state.amount*100)/100 === Math.round(Math.abs(this.state.amount_to_stl)*100)/100) ? Math.round(Math.abs(this.state.amount_to_stl)*100)/100 : Math.round(Math.abs(this.state.amount)*100)/100,
                     "role": this.props.user.role,
                     "settle": true,
                     "username": this.props.user.username
                  }
               ]
            }
            body = this.clean(body);
            if (this.props.user.role !== "Client") {
               await UserSettlementService.postMasterSettlement(body).then((res) => {
                  if (res.isSuccess) {
                     this.props.notify("Settlement Successfully Done", "success");
                     setTimeout(() => { this.props.closeAndUpdate() }, 2000)
                  }
                  else {
                     this.props.notify(res.exception.message, "error")
                  }
               })
            }
            else {
               await UserSettlementService.postClientSettlement(body).then((res) => {
                  if (res.isSuccess) {
                     this.props.notify("Settlement Successfully Done", "success");
                     setTimeout(() => { this.props.closeAndUpdate() }, 2000)
                  }
                  else {
                     this.props.notify(res.exception.message, "error")
                     this.setState({buttonLoading: false})
                  }
               })
            }
         })
      }
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   onAmountChange(e) {
      const name = e.target.name;
      let value = Math.abs(e.target.value);
      if (value === 0) {
         this.setState({ [name]: "" })
      }
      else {
         this.setState({ [name]: value })
      }
   }
   handleKey(e) {
      if (e.keyCode === 13) {
         this.submitData();
      }
   }
   componentDidMount() {
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)

      if (this.props.user.upLineBalance > 0) {
         let total = this.props.user.exposure + this.props.user.availableBalance
         let stl_amt = 0
         if (total >= 0) {
            stl_amt = this.props.user.upLineBalance
         } else if((this.props.user.upLineBalance + total) >= 0) {
            stl_amt = this.props.user.upLineBalance + total
         }
         this.setState({ currUserData: currUserData, amount_to_stl: stl_amt, loading: false, remark: `${currUserData.username} paid cash to ${this.props.user.username}` })
      } else {
         this.setState({ currUserData: currUserData, amount_to_stl: this.props.user.upLineBalance, loading: false, remark: `${currUserData.username} received cash from ${this.props.user.username}` })
      }
   }
   render() {
      return (
         <>
            {!this.state.loading &&
               <div className="modal fade show settlementinput" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
                  <div className="modal-dialog modal-dialog-scrollable">
                     <div className="modal-content">
                        <div className="modal-header">
                           <h4 className="modal-title">Settlement</h4>
                           <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                        </div>
                        <div className="modal-body lst-pop ">
                           <div className="row m-b-20">
                              <div className="col-md-4">
                                 <label className="font-weight-bold">User Name:</label>
                              </div>
                              <div className="col-md-8">
                                 <label>{this.props.user.username}</label>
                              </div>
                           </div>
                           <div className="row mb-1">
                              <div className="col-6 col-md-6">
                                 <label className="d-block font-weight-bold">My Available Bal </label>
                                 <label className="d-block">{!!this.state.currUserData.availableBalance ? <Currency className="fbold" amount={this.state.currUserData.availableBalance} showColor={true} /> : "0.00"}</label>
                              </div>
                              <div className="col-6 col-md-6">
                                 <label className="d-block font-weight-bold">P&amp;L </label>
                                 <label className="d-block">{!!this.props.user.upLineBalance ? <Currency className="fbold" amount={this.props.user.upLineBalance} showColor={true} /> : "0.00"}</label>
                              </div>
                           </div>
                           <div className="row mb-1">
                              <div className="col-6 col-md-6">
                                 <label className="d-block font-weight-bold">Exposure </label>
                                 <label className="d-block">{!!this.props.user.exposure ? <Currency className="fbold" amount={this.props.user.exposure} showColor={true} /> : "0.00"}</label>
                              </div>
                              <div className="col-6 col-md-6">
                                 <label className="d-block font-weight-bold">Amount To Settle </label>
                                 <label className="d-block"><Currency className="fbold" amount={this.state.amount_to_stl} showColor={true} /></label>
                              </div>
                           </div>
                           <div className="row m-b-20">
                              <div className="col-md-4">
                                 <label className="font-weight-bold">Settle Amount</label>
                              </div>
                              <div className="col-md-8">
                                 <input type="number" tabIndex="1" name="amount" value={this.state.amount} onChange={(e) => { this.onAmountChange(e) }} className="form-control w-75 d-inline br-remove" placeholder="" />
                                 <button className="btn btn-primary btn-sm ml-1" onClick={(e) => { this.setState({ amount: parseFloat(Math.abs(this.state.amount_to_stl)).toFixed(2) }) }}>Full Settle</button>
                              </div>
                           </div>
                           <div className="row m-b-20">
                              <div className="col-md-4">
                                 <label className="font-weight-bold">Remarks</label>
                              </div>
                              <div className="col-md-8">
                                 <textarea name="remark" tabIndex={2} id="deposit-remark" onChange={(e) => { this.change(e) }} value={this.state.remark}></textarea>
                              </div>
                           </div>
                           <div className="row m-b-20 mb-2">
                              <div className="col-md-4">
                                 <label className="font-weight-bold">Master Password</label>
                              </div>
                              <div className="col-md-8">
                                 <input type="Password" tabIndex={3} name="mpassword" id="mpassword" onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.change(e) }} required="" />
                              </div>
                           </div>
                        </div>
                        <div className="modal-footer">
                           <a className="pop-edit-btn" tabIndex="4" onClick={() => { this.submitData() }} style={{ cursor: "pointer" }}>Submit {this.state.buttonLoading && <img alt="" style={{ height: "16px" }} src={BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</a>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>
                        </div>
                        {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                     </div>
                  </div>
                  <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>
            }
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(SettlementModel);